<template>
  <div :style="{transform: 'scale('+scal+')' }" class="cooperation">
    <div class="new-title">
      {{
        $theme
          ? "与国内顶级院校、世界级企业强强联手，产学研结合带动科研储备"
          : "Joining forces with top domestic universities and world-class companies to promote scientific research reserves through the integration of industry, academia and research"
      }}
    </div>
    <div class="list">
      <!--            <img :src="require(`@/assets/img/brand-honor/cooperation-${item.id}${active === item.id?'-active':''}.png`)">-->

      <div
        v-for="item in list"
        :key="item.id"
        :class="`item ${active === item.id ? 'active' : ''}`"
        :style="{
          order: getOrder(item.id),
          marginLeft: getOrder(item.id) == 2 ? '-330px' : 0,
        }"
        @click="active = item.id"
      >
        <img
          :src="`/image/brand-honor/cooperation/${$theme ? item.name : item.nameEng}-active.png`"
          v-show="active === item.id"
          @click="active = item.id"
        />
        <img
          :src="`/image/brand-honor/cooperation/${$theme ? item.name : item.nameEng}.png`"
          v-show="active != item.id"
          @click="active = item.id"
        />
      </div>
      
    </div>
  </div>
</template>

<script>


export default {
  name: "PropertyRights",
  components: {
    
  },
  data() {
    return {
      active: 1,
      list: [
        {
          id: 1,
          name: "北理工",
          nameEng: "北理工en",
        },
        {
          id: 2,
          name: "清华",
          nameEng: "清华en",
        },
        {
          id: 3,
          name: "戴尔",
          nameEng: "戴尔en",
        },
      ],
      scal: 1,
    };
  },
  methods: {
    getOrder(id) {
      let order = 0;
      if (id === this.active) {
        order = 1;
      } else if (id < this.active) {
        if (id === this.active - 2) {
          order = 2;
        } else {
          order = 0;
        }
      } else {
        if (id === this.active + 1) {
          order = 2;
        } else {
          order = 0;
        }
      }
      return order;
    },
  },
  mounted() {
    var element = document.body.clientWidth;
    // this.scal = element/1920
    
  }
};
</script>
<style lang="scss" scoped>
@import "./Index.scss";
</style>
